jQuery(function ($) {
  
 //Initializing fancybox
  Fancybox.bind("[data-fancybox]", {});

});

//Script added to open menu on hover

 let items = document.querySelectorAll(".header__inline-menu details");
items.forEach(item => {
  let closeTimeout;

  item.addEventListener("mouseover", () => {
    clearTimeout(closeTimeout);
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 400);
  });
  item.querySelector("ul").addEventListener("mouseenter", () => {
    clearTimeout(closeTimeout)
  });

  item.querySelector("ul").addEventListener("mouseleave", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 400);
  });
});